import { GOOGLE_MAPS_API_KEY } from "env";

type GoogleMapsLibrary = "places" | "drawing" | "geometry" | "visualization" | "maps";

export const googleMapsConfig = {
  id: "google-map-script",
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: ["places", "maps"] as GoogleMapsLibrary[],
  language: "th",
  region: "TH"
};